import { useState, useEffect, useRef } from "react";
import {
  Box,
  Input,
  IconButton,
  Flex,
  Text,
  FormControl,
  InputGroup,
  InputRightElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { CloseIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import GlobalSearch from "../../components/app/GlobalSearch";

const HotkeySearchOverlay = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const inputRef = useRef(null);

  // Background and text colors based on color mode
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.800", "white");
  const placeholderColor = useColorModeValue("gray.400", "gray.500");

    useEffect(() => {
    // Handler for cmd+shift+f or ctrl+shift+f
    const captureF = (event) => {
      if (
        (event.metaKey || event.ctrlKey) &&
        event.shiftKey &&
        (event.key === "f" || event.key === "F")
      ) {
        console.log("Captured Cmd+Shift+F"); // For debugging
        event.preventDefault();
        event.stopPropagation();
        setIsOpen(true);
        return false;
      }
    };
  
    // Backup approach using keyCode (older but sometimes more reliable)
    const backupCaptureF = (event) => {
      // KeyCode 70 is 'F'
      if (
        (event.metaKey || event.ctrlKey) && 
        event.shiftKey &&
        event.keyCode === 70
      ) {
        console.log("Backup captured Cmd+Shift+F"); // For debugging
        event.preventDefault();
        event.stopPropagation();
        setIsOpen(true);
        return false;
      }
    };

    // Handle escape key
    const handleEscape = (event) => {
      if (event.key === "Escape" && isOpen) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    // Use all three approaches with capture phase
    document.addEventListener("keydown", captureF, true);
    document.addEventListener("keydown", backupCaptureF, true);
    document.addEventListener("keydown", handleEscape);

    return () => {
      // Clean up all event listeners
      document.removeEventListener("keydown", captureF, true);
      document.removeEventListener("keydown", backupCaptureF, true);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  // Focus the input when overlay opens
  useEffect(() => {
    if (isOpen && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 10);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
    setSearchTerm("");
  };

  if (!isOpen) return null;

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="blackAlpha.400"
      display="flex"
      justifyContent="center"
      paddingTop="100px"
      zIndex="modal"
      backdropFilter="blur(3px)"
      onClick={handleClose}
    >
      <Flex flexDir="column" alignItems="center">
        <Box
          h="fit-content"
          maxW="2xl"
          rounded="lg"
          bg={bgColor}
          onClick={(e) => e.stopPropagation()}
        >
            {isOpen && (
                <GlobalSearch />
            )}
        </Box>
        <Box
          fontSize="46px"
          fontWeight="600"
          color="brand.gray.400"
          mt="16px"
          bg="transparent"
        >
          What are you looking for?
        </Box>
      </Flex>
    </Box>
  );
};

export default HotkeySearchOverlay;
